import React, { Component } from 'react';
import { Stage, Layer} from 'react-konva';
import { RhombusList } from './RhombusList.js';
import { Globals } from './Globals.js';
import { VertexCandidates } from './VertexCandidates.js';
import Box from '@mui/material/Box';
import assert from './Assert.js';
import { LINE_SIZE, Rhombus, COUNTER_CLOCKWISE, CLOCKWISE, RVA, RVB, RVC, RVD, RVE, RVF, RVG, RVH } from './Rhombus.js';

var Point = require('./Point');

const GS_START = 0;
const GS_STOP = 1;
const GS_BUILD_VERTICES = 2;
const GS_GROW_RHOMBUSES = 3;

const stageCanvasRef= React.createRef();

class Drawing extends Component {

  state = {
    rhombus_list: null,
    rhombus_to_display: null,
    stageWidth: 300,
    stageHeight: 300 
  };
  vc_to_display = null;
  grow_state = GS_START;
  grow_point = null;
  candidate_vertices = null;

  componentDidMount() {
    // this.test_non_adjacent_candidates();
    // this.test_non_adjacent_candidates_2();
    // this.test_add_4_corners_and_wraparound();
    this.interval = setInterval(this.tick, 200); // 0.5-second delta
    this.checkSize();
    window.addEventListener("resize", this.checkSize);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    window.removeEventListener("resize", this.checkSize);
  }

  checkSize = () => { 
    let container = document.querySelector('#stage-canvas');
    const width = container.offsetWidth;
    this.setState({
      stageWidth: width
    });
    const height = container.offsetHeight;
    this.setState({
      stageHeight: height
    });
  }

  grow_rhombus() {
    let globals = new Globals();
    switch(this.grow_state) {
      case GS_START:
        this.grow_point = new Point(this.state.stageWidth/2, this.state.stageHeight/2);
        let rl = new RhombusList();
        this.candidate_vertices = new VertexCandidates( this.grow_point, rl);
        assert(this.candidate_vertices.initialize());
        let r = this.candidate_vertices.generate_rhombus();
        rl.add(r);
        this.setState({ rhombus_list: rl });
        this.grow_state = GS_BUILD_VERTICES;
        break;
      case GS_BUILD_VERTICES:
        this.candidate_vertices = new VertexCandidates( this.grow_point, this.state.rhombus_list);
        this.vc_to_display = this.candidate_vertices;
        if (!this.candidate_vertices.initialize()) {
          // this will cause a hole in the pattern
          this.grow_state = GS_STOP;
          globals.status_message = Globals.SM_STOPPED_DUE_TO_HOLE;
          // console.log('Offending grow_point ', 
          //      this.state.rhombus_list.get_external_vertex_number(this.grow_point));
          break;
        }
        this.grow_state = GS_GROW_RHOMBUSES;
      case GS_GROW_RHOMBUSES:
        let r2 = this.candidate_vertices.generate_rhombus();
        if (!r2) {
          // for some reason, perhaps overlap, this vertex can not be 
          // completely filled with rhombuses
          this.grow_state = GS_STOP;
          break;
        }

        const { rhombus_list } = this.state;
        rhombus_list.add(r2);
        this.setState({rhombus_list});

        if (this.candidate_vertices.get_size() <= 0) {
          let next_gp = this.state.rhombus_list.get_next_growth_vertex(this.state.stageWidth, this.state.stageHeight);
          if (next_gp) {
            this.grow_point = next_gp;
            this.grow_state = GS_BUILD_VERTICES;
          } else {
            // no more growth points, we are done
            globals.status_message = Globals.SM_FINISHED;
            this.grow_state = GS_STOP;
          }
        }
        break;
      case GS_STOP:
        globals.cp_state = Globals.CP_STOP;
        break;
      default:
        throw `invalid grow_state: ${this.grow_state}`;
    }
  }

  cp_fsm_tick_processor() {
    let globals = new Globals();
    switch(globals.cp_state) {
      case Globals.CP_STOP:
        break
      case Globals.CP_DRAW:
        try {
          this.grow_rhombus();
        } catch (error) {
         globals.status_message = Globals.SM_INTERNAL_ERROR;
         this.grow_state = GS_STOP;
        }
        break;
      case Globals.CP_RESET:
        const { rhombus_list } = this.state;
        rhombus_list.reset();
        this.setState({rhombus_list});
        this.candidate_vertices = null;
        this.grow_state = GS_START;
        globals.status_message = Globals.SM_INITIAL_STATE;
        break;
      default:
        throw `invalid cp_state: ${globals.cp_state}`;
    }
  }

  tick = () => {
    this.cp_fsm_tick_processor();
  }

  render() {
    // Stage is a div container
    // Layer is actual canvas element (so you may have several canvases in the stage)
    // And then we have canvas shapes inside the Layer
    //  <div style={{ width: "100vw", height: "100vh", border: "1px solid grey" }} ref={(node) => { this.container = node; }}>
    return (
      <div style={{ width:"100vw", height:"100vh" }} id="stage-canvas" ref={stageCanvasRef}>
        <Stage width={this.state.stageWidth} height={this.state.stageHeight}>
          <Layer>
            {this.state.rhombus_list && this.state.rhombus_list.render()}
            {Globals.DEBUG && this.state.rhombus_to_display && this.state.rhombus_to_display.render(5)}
            {Globals.DEBUG && this.vc_to_display && this.vc_to_display.render()}
          </Layer>
        </Stage>
      </div>
    );
  }
}


export default Drawing;
